import ActionTypes from './ActionTypes';
import AppDispatcher from './AppDispatcher';
import LocalStorage from './utils/LocalStorage';
import AdminPageTypes from './views/AdminPageTypes';
import WebApiUtils from './WebApiUtils';
import Papa from 'babyparse';
import Permissions from './domain/Permissions';
import _ from 'lodash';
import LandPageTypes from './views/LandPageTypes';

class ClientActions {
    start(user, token, landPage, adminPage) {
        let that = this;

        function resetAllAndShowLogin() {
            LocalStorage
                .updateToken(null)
                .updateLandPage(null)
                .updateAdminPage(null)
                .saveState();

            AppDispatcher.dispatch({
                type: ActionTypes.START,
                user,
                token,
                landPage: LandPageTypes.LOGIN,
            });
        }

        if (user && token && landPage === LandPageTypes.ADMIN && adminPage) {
            WebApiUtils
                .revalidateToken(token)
                .then(function (newToken) {
                    LocalStorage
                        .updateToken(newToken)
                        .saveState();

                    AppDispatcher.dispatch({
                        type: ActionTypes.START,
                        user,
                        token: newToken,
                        landPage,
                    });

                    that.chooseMenu(adminPage, token).catch(resetAllAndShowLogin);
                })
                .catch(resetAllAndShowLogin);
        } else {
            resetAllAndShowLogin();
        }
    }

    login(username, password, lastMenu) {
        WebApiUtils
            .loginAsync(username, password)
            .then(result => {
                let user = result.user;
                let adminPage = null;
                let map = _.keys(Permissions);

                for (let i = 0; i < map.length; i++) {
                    let key = map[i];

                    if (user.hasPermission(Permissions[key].name)) {
                        adminPage = Permissions[key].initialPage;
                        break;
                    }
                }

                if (adminPage === null)
                    adminPage = AdminPageTypes.BLANK;

                this.chooseMenu(lastMenu ? lastMenu : adminPage, result.token);
            });
    }

    error(e) {
        this.showDialog('Erro', e.message);
    }

    showDialog(title, message) {
        AppDispatcher.dispatch({
            type: ActionTypes.OPEN_DIALOG,
            title,
            message,
        });
    }

    closeDialog() {
        AppDispatcher.dispatch({
            type: ActionTypes.CLOSE_DIALOG
        });
    }

    verifyCpf(cpf, event, token) {
        WebApiUtils.verifyCpfAsync(cpf, event, token);
    }

    printBadge(usualName, participant, event, token) {
        WebApiUtils.printBadgeAsync(usualName, participant, event, token);
    }

    linkCourseware(participant, event, coursewareId, token) {
        WebApiUtils.linkCoursewareAsync(participant, event, coursewareId, token)
    }

    printTicket(course, coursewareIds, token, success, error) {
        WebApiUtils
            .printTicketAsync(course, coursewareIds, token)
            .then(success)
            .catch(error);
    }

    updateText(field, value) {
        AppDispatcher.dispatch({
            type: ActionTypes.UPDATE_TEXT,
            field,
            value
        });
    }

    logout() {
        LocalStorage
            .updateToken(null)
            .updateLandPage(null)
            .updateAdminPage(null)
            .saveState();

        AppDispatcher.dispatch({
            type: ActionTypes.LOGOUT
        });
    }

    toCredenciamento(cpf, token) {
        // TODO: melhorar este código

        this.chooseMenu(AdminPageTypes.CREDENCIAMENTO, token);

        AppDispatcher.dispatch({
            type: ActionTypes.CHOOSE_MENU_FINISH,
            menu: AdminPageTypes.CREDENCIAMENTO,
            cpf
        });
    }

    chooseMenu(menu, token) {
        if (menu === AdminPageTypes.LOGOUT) {
            this.logout();
            return;
        }

        AppDispatcher.dispatch({
            type: ActionTypes.CHOOSE_MENU_START,
            menu
        });

        let promise = null;

        switch (menu) {
            case AdminPageTypes.CREDENCIAMENTO:
            case AdminPageTypes.PARTICIPANTES_LIMITED:
            case AdminPageTypes.IMPORTACAO:
            case AdminPageTypes.IMPORTACAO_PRODUTOS:
                promise = WebApiUtils.selectEventsAsync(token);
                break;

            case AdminPageTypes.PARTICIPANTES:
                promise = WebApiUtils.selectEventsAsync(token);
                promise = promise.then(token1 => WebApiUtils.selectCentersAsync(token1));
                break;

            case AdminPageTypes.PRESENCA:
                promise = WebApiUtils.selectAttendanceColumnsAsync(token);
                promise = promise.then(token1 => WebApiUtils.selectEventsAsync(token1));
                break;

            case AdminPageTypes.PERFIS:
                promise = WebApiUtils.selectPermissionsAsync(token);
                break;

            case AdminPageTypes.USUARIOS:
                promise = WebApiUtils.selectPermissionsAsync(token);
                promise = promise.then(token1 => WebApiUtils.selectProfilesAsync(token1));
                promise = promise.then(token1 => WebApiUtils.selectCentersAsync(token1));
                promise = promise.then(token1 => WebApiUtils.selectProductCategoriesAsync(token1));
                break;

            case AdminPageTypes.PRODUTOS:
                promise = WebApiUtils.selectProductCategoriesAsync(token);
                break;

            case AdminPageTypes.CIDADES:
                promise = WebApiUtils.selectCountriesAsync(token);
                break;

            case AdminPageTypes.NUCLEOS:
                promise = WebApiUtils.selectCitiesAsync(token);
                break;

            case AdminPageTypes.EVENTS:
                promise = WebApiUtils.selectCoursesAsync(token);
                break;

            case AdminPageTypes.APOSTILAS:
                promise = WebApiUtils.selectCoursesAsync(token);
                promise = promise.then(token1 => WebApiUtils.selectCentersAsync(token1));
                break;

            case AdminPageTypes.VENDA:
            case AdminPageTypes.VENDA_CAIXA:
            case AdminPageTypes.VENDA_CAIXA_EXPEDICAO:
                promise = WebApiUtils.listProductsAsync(token);
                break;

            case AdminPageTypes.CAIXA:
            case AdminPageTypes.CAIXA_EXPEDICAO:
                promise = WebApiUtils.listOpenOrdersAsync(token);
                break;

            case AdminPageTypes.EXPEDICAO:
                promise = WebApiUtils.listClosedOrdersAsync(token);
                break;

            case AdminPageTypes.RELATORIO_DASHBOARD:
                promise = WebApiUtils.listDashboardAsync(token);
                promise = promise.then(token1 => WebApiUtils.selectEventsAsync(token1));
                break;

            case AdminPageTypes.RELATORIO_VENDAS_TOTAIS:
            case AdminPageTypes.RELATORIO_VENDAS_POR_PAGAMENTO:
            case AdminPageTypes.RELATORIO_APOSTILAS_POR_NUCLEO:
                promise = WebApiUtils.selectEventsAsync(token);
                break;

            case AdminPageTypes.RELATORIO_VENDAS_DOS_NUCLEOS:
                promise = WebApiUtils.selectCentersAsync(token);
                promise = promise.then(token1 => WebApiUtils.selectEventsAsync(token1));
                promise = promise.then(token1 => WebApiUtils.selectProductCategoriesAsync(token1));
                break;

            case AdminPageTypes.RELATORIO_VENDAS_PARA_NUCLEOS:
                promise = WebApiUtils.selectCentersAsync(token);
                promise = promise.then(token1 => WebApiUtils.selectEventsAsync(token1));
                promise = promise.then(token1 => WebApiUtils.selectProductCategoriesAsync(token1));
                break;

            case AdminPageTypes.RELATORIO_VENDAS_POR_PRODUTOS:
                promise = WebApiUtils.selectProductCategoriesAsync(token);
                promise = promise.then(token1 => WebApiUtils.selectEventsAsync(token1));
                break;

            case AdminPageTypes.SORTEIO:
                promise = WebApiUtils.selectProductsAsync(token);
                promise = promise.then(token1 => WebApiUtils.selectEventsAsync(token1));
                promise = promise.then(token1 => WebApiUtils.listPaidOrdersAsync(token1));
                break;

            case AdminPageTypes.PEDIDOS_PAGOS:
                promise = WebApiUtils.listPaidOrdersAsync(token);
                break;

            case AdminPageTypes.RELATORIO_CARRINHOS_PAGOS:
                promise = WebApiUtils.listPaymentMethodsAsync(null, token);
                promise = promise.then(token1 => WebApiUtils.selectEventsAsync(token1));
                break;

            case AdminPageTypes.RELATORIO_COMPRADORES_POR_PRODUTO:
                promise = WebApiUtils.selectProductsAsync(token);
                promise = promise.then(token1 => WebApiUtils.selectEventsAsync(token1));
                break;

            case AdminPageTypes.DISTRIBUICAO_VENDAS:
                promise = WebApiUtils.listAmountBySlotAsync(token);
                promise = promise.then(token1 => WebApiUtils.selectEventsAsync(token1));
                break;

            case AdminPageTypes.ACUMULADO_VENDAS:
                promise = WebApiUtils.selectEventsAsync(token);
                break;

            default:
                promise = Promise.resolve(token);
        }

        return promise.then(token1 => {
            LocalStorage
                .updateAdminPage(menu)
                .saveState();

            AppDispatcher.dispatch({
                type: ActionTypes.CHOOSE_MENU_FINISH,
                menu
            });
        });
    }

    updateDashboard(token, eventId) {
        WebApiUtils.listDashboardAsync(token, eventId);
    }

    selectEvent(id, callback, token) {
        let promise = WebApiUtils.selectEventAsync(id, token);

        if (callback) {
            promise.then(function () {
                callback();
            });
        }
    }

    selectRelatorio(relatorioId) {
        AppDispatcher.dispatch({
            type: ActionTypes.SELECT_RELATORIO,
            relatorioId
        });
    }

    selectCourseForCourseware(courseId) {
        AppDispatcher.dispatch({
            type: ActionTypes.SELECT_COURSE_FOR_COURSEWARE,
            courseId
        });
    }

    selectEventForParticipants(eventId) {
        AppDispatcher.dispatch({
            type: ActionTypes.SELECT_EVENT_FOR_PARTICIPANTS,
            eventId
        });
    }

    importSheet(file, event, callback, token) {
        WebApiUtils.importSheetAsync(file, event, token).then(callback);
    }

    importSheetProducts(file, event, callback, token) {
        WebApiUtils.importSheetProductsAsync(file, event, token).then(callback);
    }

    selectEventForImportacao(eventId) {
        AppDispatcher.dispatch({
            type: ActionTypes.SELECT_EVENT_FOR_IMPORT,
            eventId
        });
    }

    downloadCsv(data, name) {
        let csv = Papa.unparse(data);

        // TODO: criar função no utils pra isso

        let id = 'downloadFile';
        let idselector = '#' + id;

        if ($(idselector).length > 0) {
            $(idselector).remove();
        }

        $('<a></a>')
            .attr('id', id)
            .attr('href', 'data:text/csv;charset=utf8,' + encodeURIComponent(csv))
            .attr('download', name + '.csv')
            .appendTo('body');

        $(idselector).ready(function() {
            $(idselector).get(0).click();
        });
    }

    selectCategoria(categoriaId) {
        AppDispatcher.dispatch({
            type: ActionTypes.SELECT_CATEGORIA,
            categoriaId
        });
    }

    selectNucleo(nucleoId) {
        AppDispatcher.dispatch({
            type: ActionTypes.SELECT_NUCLEO,
            nucleoId
        });
    }

    updateCartItems(cartId, update, token) {
        if (!cartId) {
            return WebApiUtils.createCartAsync(token)
                .then(({token, id}) => WebApiUtils.updateCartItemAsync(id, update, token)
                    .then(token1 => WebApiUtils.listCartItemsAsync(id, token1))
                    .then(token2 => WebApiUtils.listOpenOrdersAsync(token2)));
        } else {
            return WebApiUtils.updateCartItemAsync(cartId, update, token)
                .then(token1 => WebApiUtils.listCartItemsAsync(cartId, token1))
                .then(token2 => WebApiUtils.listOpenOrdersAsync(token2));
        }
    }

    closeCart(cartId, clientId, token) {
        return WebApiUtils.closeCartAsync(cartId, clientId, token);
    }

    deleteCart(cartId, token) {
      WebApiUtils.deleteCartAsync(cartId, token)
        .then(token1 => WebApiUtils.listOpenOrdersAsync(token1));
    }

    selectOpenOrder(orderId, token) {
        AppDispatcher.dispatch({
            type: ActionTypes.SELECT_OPEN_ORDER,
            orderId
        });
        if (orderId) {
            WebApiUtils.listPaymentMethodsAsync(orderId, token);
        }
    }

    updatePayment(newValue) {
        AppDispatcher.dispatch({
            type: ActionTypes.UPDATE_PAYMENT_SPLIT,
            payment: newValue,
        });
    }

    closeOrder(orderId, payment, token) {
        return WebApiUtils.closeOrderAsync(orderId, payment, token)
            .then(token2 => WebApiUtils.listOpenOrdersAsync(token2));
    }

    printOrder(orderId, token, type) {
        if (type === 'receipt')
            return WebApiUtils.printOrderReceiptAsync(orderId, token);
        if (type === 'delivery')
            return WebApiUtils.printOrderDeliveryAsync(orderId, token);
        return WebApiUtils.printOrderReceiptAsync(orderId, token)
            .then(token1 => WebApiUtils.printOrderDeliveryAsync(orderId, token1));
    }

    selectClosedOrder(orderId, token) {
        AppDispatcher.dispatch({
            type: ActionTypes.SELECT_CLOSED_ORDER,
            orderId
        });
    }

    deliverOrder(orderId, token) {
        return WebApiUtils.deliverOrderAsync(orderId, token)
            .then(token1 => WebApiUtils.printOrderDeliveryAsync(orderId, token1))
            .then(token2 => WebApiUtils.listClosedOrdersAsync(token2));
    }

    showSwal(title, text, onConfirm, onCancel) {
        AppDispatcher.dispatch({
            type: ActionTypes.SHOW_SWAL,
            title,
            text,
            onConfirm,
            onCancel,
        });
        return Promise.resolve();
    }

    closeSwal() {
        AppDispatcher.dispatch({
            type: ActionTypes.CLOSE_SWAL
        });
    }

    findClientName(cpf, token) {
        WebApiUtils.findClientNameAsync(cpf, token);
    }

    updateOrdersLists(token) {
        return WebApiUtils.listClosedOrdersAsync(token)
            .then(token2 => WebApiUtils.listOpenOrdersAsync(token2));
    }

    updateEmailEditor(editorContent) {
        AppDispatcher.dispatch({
            type: ActionTypes.UPDATE_EMAIL_EDITOR,
            editorContent,
        });
    }

    updateLotteryConfig(field, value) {
        AppDispatcher.dispatch({
            type: ActionTypes.UPDATE_LOTTERY_CONFIG,
            field,
            value,
        });
    }

    configureLottery(eventId, criteria, token) {
        AppDispatcher.dispatch({
            type: ActionTypes.CONFIGURE_LOTTERY
        });
        WebApiUtils.createLotteryGameAsync(eventId, token)
            .then(({token, id}) => WebApiUtils.updateLotteryGameAsync(id, [], criteria, token));
    }

    addLotteryWinner(gameId, winner, token) {
            WebApiUtils.updateLotteryGameAsync(gameId, [winner], [], token);
    }

    closeLottery() {
        AppDispatcher.dispatch({
            type: ActionTypes.CLOSE_LOTTERY
        });
    }

    runLottery() {
        AppDispatcher.dispatch({
            type: ActionTypes.RUN_LOTTERY
        });
    }

    listParticipants(eventId, token) {
        return WebApiUtils.listParticipantsAsync(eventId, token);
    }

    selectPaidOrder(orderId) {
        AppDispatcher.dispatch({
            type: ActionTypes.SELECT_PAID_ORDER,
            orderId
        });
    }

    listPaidOrders(token) {
        WebApiUtils.listPaidOrdersAsync(token);
    }

    listAmountBySlot(eventId, from, to, token) {
        WebApiUtils.listAmountBySlotAsync(token, eventId, from, to);
    }
}

export default new ClientActions();



// WEBPACK FOOTER //
// src/Actions.js